// src/utils/passwordValidator.js

/**
 * Validates password against complexity requirements:
 * - At least 8 characters
 * - At least one uppercase letter (A-Z)
 * - At least one lowercase letter (a-z)
 * - At least one number (0-9)
 * - At least one symbol / special character
 *
 * @param {string} password
 * @returns {{
 *   isValid: boolean,
 *   score: number,
 *   checks: {
 *     minLength: boolean,
 *     hasUppercase: boolean,
 *     hasLowercase: boolean,
 *     hasNumber: boolean,
 *     hasSymbol: boolean
 *   },
 *   errors: string[]
 * }}
 */
export const validatePassword = (password) => {
  const pwd = typeof password === 'string' ? password : '';

  const checks = {
    minLength: pwd.length >= 8,
    hasUppercase: /[A-Z]/.test(pwd),
    hasLowercase: /[a-z]/.test(pwd),
    hasNumber: /\d/.test(pwd),
    hasSymbol: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(pwd) || /[^a-zA-Z0-9]/.test(pwd)
  };

  const errors = [];
  if (!checks.minLength) errors.push('minLength');
  if (!checks.hasUppercase) errors.push('uppercase');
  if (!checks.hasLowercase) errors.push('lowercase');
  if (!checks.hasNumber) errors.push('number');
  if (!checks.hasSymbol) errors.push('symbol');

  const passedCount = Object.values(checks).filter(Boolean).length;
  const isValid = passedCount === 5;

  return {
    isValid,
    score: passedCount,
    checks,
    errors
  };
};

export const getPasswordErrorMessage = (t, defaultMessage = '') => {
  if (t && typeof t === 'function') {
    return t('passwordValidation.errorMessage', defaultMessage || 'Le mot de passe doit comporter au moins 8 caractères, une majuscule, une minuscule, un chiffre et un symbole.');
  }
  return defaultMessage || 'Le mot de passe doit comporter au moins 8 caractères, une majuscule, une minuscule, un chiffre et un symbole.';
};
